import { useEffect, useState } from "react";
import {
  Box,
  Divider,
  Typography,
  Stack,
  IconButton,
  Popover,
  Avatar,
  Badge,
  styled,
  useMediaQuery
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { dashboard } from "../../../store/dashboardSlice";

export default function AccountPopover({ accountDetails }) {
  // console.log("Account Details:", accountDetails);
  const [open, setOpen] = useState(null);
  const isMobile = useMediaQuery('(max-width:600px)');

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  // const dispatch = useDispatch();
  // const { data, status } = useSelector((state) => state.dashboard);

  // useEffect(() => {
  //   dispatch(dashboard());
  // }, []);

  // const {
  //   customer_name,
  //   client_email,
  // } = data;

  const StyledBadge = styled(Badge)(({ theme }) => ({
    '& .MuiBadge-badge': {
      backgroundColor: '#44b700',
      color: '#44b700',
      boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
      '&::after': {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        borderRadius: '50%',
        animation: 'ripple 1.2s infinite ease-in-out',
        border: '1px solid currentColor',
        content: '""',
      },
    },
    '@keyframes ripple': {
      '0%': {
        transform: 'scale(.8)',
        opacity: 1,
      },
      '100%': {
        transform: 'scale(2.4)',
        opacity: 0,
      },
    },
  }));

  const navigate = useNavigate();
  const handleClose = () => {
    setOpen(null);
  };
  const handleLogOut = () => {
    axios.get("/support/logout").then((response) => {
      if (response.data === "Logged out") {
        sessionStorage.removeItem("token");
        navigate("/login");
      }
    });
  };

  return (
    <>
      <IconButton
        onClick={handleOpen}
        sx={{
          p: 0,
          ...(open && {
            "&:before": {
              zIndex: 1,
              content: "''",
              width: "100%",
              height: "100%",
              borderRadius: "50%",
              position: "absolute",
            },
          }),
        }}
      >
        <Stack
          direction={"row"}
          spacing={1}
          alignItems={"center"}
          justifyContent={"start"}
        >
          <Box className="sideBarImg">
          <StyledBadge
                  overlap="circular"
                  anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  variant="dot"
                >
                  <Avatar alt={accountDetails.email} src="" />
                </StyledBadge>
          </Box>
          <Stack alignItems={"start"} sx={{ color: "black" }}>
            {/* <h6>{customer_name}</h6>
            <p style={{ fontSize: "small" }}>{client_email}</p> */}
            <Typography variant="h6" sx={{ fontSize: isMobile ? 'small' : '' }}>
              {accountDetails.customer_name}
            </Typography>
            <Typography variant="body2" sx={{ fontSize: isMobile ? 'x-small' : '' }}>
              {accountDetails.email}
            </Typography>
          </Stack>
        </Stack>
      </IconButton>
      {/* <Popover
        open={false}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            p: 0,
            mt: 1.5,
            ml: 0.75,
            width: 180,
            "& .MuiMenuItem-root": {
              typography: "body2",
              borderRadius: 0.75,
            },
          },
        }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle2" noWrap>
            {customer_name}
          </Typography>
          <Typography variant="body2" sx={{ color: "text.secondary" }} noWrap>
            {client_email}
          </Typography>
        </Box>
        <Divider sx={{ borderStyle: "dashed" }} />
      </Popover>      */}
    </>
  );
}
